import {
    Table,
    Row,
    Col,
    Accordion,
    Card,
    OutlineButton,
    PrimaryButton,
    InputField,
    PopupDialogbox,
    Breadcrumb,
    EventHandler,
} from "../../../CommonComponents";
import LeaderOrder from "./LeadrOrder";
import Pending from "../../../assets/images/Myorder_Pending Approval.png";
import "./ApprovalOrder.scss";
import Moment from "moment";
import permissions, { ACCESS_DENIED, isAuthorized } from "client/utils/Permissions";
import { CONSTANTS } from "client/utils/constants";
import ApprovalHistoryTimeLineCommon from "client/CommonComponents/ApprovalHistoryTimeLineCommon";

const ApprovalOrder = (props: any) => {

    const { isBulkOrder } = props
    let Comment = props.comment;
    let quantityApprovalOption = props?.quantityApprovalOption;
    let isOverrideActionapplicable = props?.isOverrideActionapplicable;
    const ExpandedItems = [
        {
            headerText: (
                <div className="accordionHeader">
                    <div className="accordionHeaderLeft mt-1">
                        <p className="accord-heading pendingapproval">
                            LEADR ORDER# - {props?.orderByIdValue?.orderId}
                        </p>
                    </div>

                    <div>

                    </div>
                    <div className="accordionHeaderRight">
                        {isOverrideActionapplicable &&
                            <span className="Admin-view pendingapproval">
                                SUPER ADMIN VIEW
                            </span>}
                        <div className="orderRequestType">
                            <label className="labelText">Request Type</label>
                            <span className="requestTypeText">
                                {isBulkOrder ? CONSTANTS.BULK_ORDER : CONSTANTS.REQUISITIONS}
                            </span>
                        </div>
                        <div>
                            <label className="labelText">Created Date</label>
                            <span className="dateContent">
                                {props?.orderByIdValue?.createdDate
                                    ? Moment(props?.orderByIdValue?.createdDate).format(
                                        "MM/DD/YYYY"
                                    )
                                    : ""}
                            </span>
                        </div>
                        <div>
                            <label className="labelText">Updated Date</label>
                            <span className="dateContent">
                                {props?.orderByIdValue?.updatedDate
                                    ? Moment(props?.orderByIdValue?.updatedDate).format(
                                        "MM/DD/YYYY"
                                    )
                                    : ""}
                            </span>
                        </div>
                    </div>
                </div>
            ),
            content: <LeaderOrder isBulkOrder={isBulkOrder} />,
            uuid: "Accordion1",
        },
        {
            headerText: (
                <>
                    <p className="accord-heading expenditure-details">
                        CAPITAL/LEASE EXPENDITURE DETAILS
                    </p>
                </>
            ),
            content: (
                <div className="p-3 expenditure_table">
                    <Table
                        data={props.capitalLeaseExpenditureData}
                        column={props.expenditureColumn}
                        className='capitalizeTable'
                     data-attribute="ApprovalOrder_Default_Table" />
                </div>
            ),
            uuid: "Accordion2",
        },
    ];

    const returnOrderconfirmation = (
        <>
            <p>
                <b>{CONSTANTS.LEADR_ORDER_NUMBER}</b> : {props?.orderByIdValue?.orderId}
            </p>
            <p>Order has been return to requestor successfully</p>
        </>
    );

    const rejectOrderconfirmation = (
        <>
            <p>
                <b>{CONSTANTS.LEADR_ORDER_NUMBER}</b> : {props?.orderByIdValue?.orderId}
            </p>
            <p>Order has been rejected</p>
        </>
    );
    const approveOrderconfirmation = (
        <>
            <p>
                <b>{CONSTANTS.LEADR_ORDER_NUMBER}</b> : {props?.orderByIdValue?.orderId}
            </p>

        </>
    );

    const returnOrdersubtext = (
        <>
            <p>
                Please provide a comment before returning order request to the requestor
            </p>
        </>
    );
    const rejectOrdersubtext = (
        <>
            <p>Please provide a comment before rejecting order</p>
            {/* <p><b>{CONSTANTS.LEADR_ORDER_NUMBER}</b> {props?.orderByIdValue?.orderId}</p> */}
        </>
    );
    const approveOrdersubtext = (
        <>
            <p>Are you sure you want to approve this order?</p>
        </>
    );
    const submitOrdersubtextFunction = (
        <>
            <p>Are you sure you want to submit this approval?</p>
        </>
    )
    const cancelOrdersubtext = (
        <>
            <p>Are you sure you want to cancel the Order</p>
            <p>
                <b>LEADR Order # : </b>{props?.orderByIdValue?.orderId}
            </p>
        </>
    );
    const cancelApprovalsubtext = (
        <>
            <p>Are you sure you want to cancel the Approval</p>
            <p>{CONSTANTS.LEADR_ORDER_NUMBER}</p>
            <p>{props?.orderByIdValue?.orderId}</p>
        </>
    );
    const errorMessage = (
        <>
            <p>Please enter comments below 500 characters</p>
        </>
    );

    return (
        <>
            <div className="pendingApproval mt-md-0" ref={props.wrapperRef}>
                <div className="clearfix breadCrumbBlock">
                    {
                        // props.mobile ?
                        //   <div className='backIcon' onClick={props.handleClickBack}>
                        //     <img src={arrowIcon} alt='back Btn'/>       
                        //   </div> :
                        <EventHandler onEvent={props.handleClickBack} data-attribute="ApprovalOrder_Default_EventHandler">
                            <div className='backButton mb-sm-2 mb-3'>
                                <span className="fa fa-chevron-left"></span>
                                Back
                            </div>
                        </EventHandler>
                    }
                    <div className="breadcrumbList">
                        <Breadcrumb items={props?.breadcrumlist} maxDisplayedItems="5"  data-attribute="ApprovalOrder_Default_Breadcrumb" />
                    </div>
                    <div className="float-right">
                        <div className="pending">
                            <img
                                src={Pending}
                                alt="Pending Approval"
                                title="Pending Appproval"
                                className="me-2"
                            />
                            <span className="pending-approval-text">Pending Approval</span>
                        </div>
                    </div>
                </div>
                <Row>
                    <Col xs={12} lg={8}>
                        <Card data-attribute="ApprovalOrder_Default_Card">
                            <Accordion
                                Items={ExpandedItems}
                                preExpanded={["Accordion1", "Accordion2"]}
                                className="custom-accordion LeaderOrderAccordion capitalLizeAccord"
                             data-attribute="ApprovalOrder_Default_Accordion" />
                            <div>
                                <p className="blueLabel mt-0">Approver Comments</p>
                                <InputField
                                    multiline
                                    resizable={false}
                                    row={4}
                                    value={props.comment}
                                    onChange={props.onChangeComment}
                                 data-attribute="ApprovalOrder_Default_Input" />
                                {props.commentError === true ? (
                                    <span className="asset-validation-msg">{errorMessage}</span>
                                ) : null}
                            </div>
                            <div className="clearfix orderBtn">
                                {(!props.approvalRequestOption?.length && !quantityApprovalOption?.length) ? (
                                    <div className="btnBlock">
                                        {props.getUserRoles()?.includes(CONSTANTS?.SUPER_ADMIN) && (
                                        <OutlineButton 
                                            disabled={!props.getUserRoles()?.includes(CONSTANTS?.SUPER_ADMIN)} 
                                            text='Cancel Order' 
                                            onClick={() => props.cancelOrderReq(cancelOrdersubtext)} 
                                            title={(props.getUserRoles()?.includes(CONSTANTS?.SUPER_ADMIN)) ? "Cancel Order" : ACCESS_DENIED} 
                                         data-attribute="ApprovalOrder_Default_Button" /> )}
                                        <OutlineButton
                                            text="Return Order to Requestor"
                                            onClick={() =>
                                                props?.returnOrderReq(returnOrdersubtext, Comment)
                                            }
                                            disabled={!isAuthorized(permissions.ApprovalsReturnToRequestor)}
                                            title={isAuthorized(permissions.ApprovalsReturnToRequestor) ? "Return Order to Requestor" : ACCESS_DENIED}
                                         data-attribute="ApprovalOrder_Default_Button_2" />
                                        <OutlineButton
                                            text="Reject Order"
                                            onClick={() =>
                                                props?.rejectOrderReq(rejectOrdersubtext, Comment)
                                            }
                                            disabled={!isAuthorized(permissions.ApprovalsReject)}
                                            title={isAuthorized(permissions.ApprovalsReject) ? "Reject Order" : ACCESS_DENIED}
                                         data-attribute="ApprovalOrder_Default_Button_3" />
                                        <PrimaryButton
                                            text="Approve Order"
                                            onClick={() =>
                                                props?.approveOrderReq(approveOrdersubtext, Comment)
                                            }
                                            disabled={props.disableApproveOrder() || !isAuthorized(permissions.ApprovalsApprove)}
                                            title={isAuthorized(permissions.ApprovalsApprove) ? "Approve Order" : ACCESS_DENIED}
                                         data-attribute="ApprovalOrder_Default_Button_4" />
                                    </div>
                                ) : (
                                    <div className="btnBlock">
                                        <OutlineButton
                                            text="Cancel"
                                            onClick={() => props?.cancelApprovalReq(cancelApprovalsubtext)}
                                         data-attribute="ApprovalOrder_Default_Button_5" />
                                        <PrimaryButton
                                            text="Submit Approval"
                                            onClick={() => props?.submitOrderReq(submitOrdersubtextFunction)}
                                            disabled={props.disableSubmitOrder()}
                                         data-attribute="ApprovalOrder_Default_Button_6" />
                                    </div>
                                )}
                            </div>
                            <PopupDialogbox
                                requestOption={props?.approvalRequestOption}
                                hideDialog={!props?.Popupcontent.isDialogVisible}
                                onDismiss={props?.hideDialog}
                                Popupcontent={props?.Popupcontent}
                                popupOutlinebtnOnclick={props?.popupOutlinebtnOnclick}
                                popupPrimarybtnOnclick={(
                                    item: any,
                                    _comments: string,
                                    actionby: string,
                                    value: any
                                ) => {
                                    props?.popupPrimarybtnOnclick(
                                        item,
                                        (_comments || props.comment),
                                        actionby,
                                        value,
                                        returnOrderconfirmation,
                                        rejectOrderconfirmation,
                                        approveOrderconfirmation
                                    );
                                }}
                                orderDetails={props?.orderByIdValue}
                             data-attribute="ApprovalOrder_Default_PopupDilalogBox" />
                        </Card>
                    </Col>
                    <Col xs={12} lg={4} className="BudgetCard">
                        <ApprovalHistoryTimeLineCommon isOrderDetail={false} approvalHistory={props?.orderByIdValue?.approvalHistory}  data-attribute="ApprovalOrder_Default_ApprovalHistoryTimeLineCommon" />
                    </Col>
                </Row>
            </div>
        </>
    );
};

export default ApprovalOrder;
